<app-nav></app-nav>
<div class="content container">
      <div class="row content-container">
        <!-- <div class="col-1"></div> -->
        <div class="col-sm-12 col-lg-6 col-md-6">
          <div class="introduction" style="z-index: 1;">
            <h3 class="app-slogan">
              Update your details
            </h3>
            <div class="user-form">
              <div *ngIf="showAlert">
                <alert [type]="alertType" dismissible="true" (onClosed)="onAlertClosed(alert)">
                  <span [innerHtml]="alertMsg"></span>
                </alert>
              </div>
              <form>
                <div class="form-group">
                  <input type="text" class="form-control" id="name" aria-describedby="nameHelp"  required [formControl]="userNameFormControl">
                  <span class="form-highlight"></span>
                  <span class="form-bar"></span>
                  <label for="name" class="float-label">Name</label>
                  <div class="invalid-input" *ngIf="userNameFormControl.invalid && (userNameFormControl.dirty || userNameFormControl.touched)">
                  Name is <strong>required</strong>
                  </div>
                </div>
                <div class="form-group">
                  <input type="email" class="form-control" id="email" aria-describedby="emailHelp" required [formControl]="emailFormControl" disabled>
                  <span class="form-highlight"></span>
                  <span class="form-bar"></span>
                  <label for="email" class="float-label">Email address</label>
                  <div class="invalid-input" *ngIf="emailFormControl.invalid && (emailFormControl.dirty || emailFormControl.touched)">
                    Please enter a valid email.
                  </div>
                </div>
                <div class="form-group">
                  <input type="number" class="form-control" id="mobile" aria-describedby="mobileHelp"  required [formControl]="mobileFormControl">
                  <span class="form-highlight"></span>
                  <span class="form-bar"></span>
                  <label for="mobile" class="float-label">Mobile Number</label>
                  <div class="invalid-input" *ngIf="mobileFormControl.invalid && (mobileFormControl.dirty || mobileFormControl.touched)">
                    Please enter a valid mobile number.
                  </div>
                </div>
                <div class="form-group">
                  <input type="password" class="form-control" id="password" required [formControl]="passwordFormControl">
                  <span class="form-highlight"></span>
                  <span class="form-bar"></span>
                  <label for="password" class="float-label">Password</label>
                  <div class="invalid-input" *ngIf="passwordFormControl.invalid && (passwordFormControl.dirty || passwordFormControl.touched)">
                    Password <strong>cannot</strong> be <strong>blank</strong>
                  </div>
                </div>
                <div class="form-group">
                  <input type="password" class="form-control" id="confirmPassword" required [formControl]="confirmPasswordFormControl">
                  <span class="form-highlight"></span>
                  <span class="form-bar"></span>
                  <label for="confirmPassword" class="float-label">Confirm password</label>
                  <div class="invalid-input" *ngIf="confirmPasswordFormControl.invalid && (confirmPasswordFormControl.dirty || confirmPasswordFormControl.touched)">
                    Password <strong>cannot</strong> be <strong>blank</strong>
                  </div>
                </div>
                <button type="submit" class="btn btn-primary" (click)="updateProfile();" [disabled]="isRegistering">Update Profile
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isRegistering"></span>
                <span class="sr-only" *ngIf="isRegistering">Please wait...</span></button>
              </form>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-lg-4 col-md-4">
          <div class="row">
            <div class="col">
              
              <div class="introduction" style="z-index: 1;">
                <h3 class="app-slogan">
                  Update your avatar
                </h3>
                </div>

              <ngx-dropzone (change)="onSelect($event)">
                <ngx-dropzone-label>Drop your files, or browse!</ngx-dropzone-label>
                <ngx-dropzone-image-preview
                  ngProjectAs="ngx-dropzone-preview"
                  *ngFor="let f of files"
                  [file]="f"
                  [removable]="true"
                  (removed)="onRemove(f)"
                >
                  <ngx-dropzone-label
                    >{{ f.name }} ({{ f.type }})</ngx-dropzone-label
                  >
                </ngx-dropzone-image-preview>
              </ngx-dropzone>
              <button
                type="button"
                class="btn btn-primary"
                (click)="uploadFiles()"
              >
                Upload
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>